<ng-container *ngIf="contentlet$ | async as contentlet">
  <div
    class="default-video-class"
    [ngStyle]="{ 'height.px': (getVideoHeight$(contentlet) | async) }"
    [ngClass]="getVideoClasses(contentlet)"
  >
    <ng-container *ngIf="buildVideoSrc('fileAsset') | async as videoSrc">
      <video
        controls
        width="100%"
        height="100%"
        [src]="videoSrc"
        playsInline
        [autoplay]="contentlet.autoPlay"
        [muted]="contentlet.mute"
        class="dotcms-video"
        style="display: block"
      ></video>
    </ng-container>
  </div>
</ng-container>
